import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartType, ChartOptions } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';

@Component({
  selector: 'app-pie-chart-cp',
  templateUrl: './pie-chart-cp.component.html',
  styleUrls: ['./pie-chart-cp.component.scss']
})
export class PieChartCPComponent implements OnInit, OnChanges {

  @Input() data = [];

  constructor() { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {

    this.pieChartLabels = [];

    changes.data.currentValue[0].totalATDP > 0 ? this.pieChartLabels.push(["ATDP", changes.data.currentValue[0].porcentajeATDP]) : null;
    changes.data.currentValue[0].totalContratos > 0 ? this.pieChartLabels.push(["Contratos", changes.data.currentValue[0].porcentajeContratos]) : null;
    changes.data.currentValue[0].totalPolizas > 0 ? this.pieChartLabels.push(["Pólizas", changes.data.currentValue[0].porcentajePolizas]) : null;
    changes.data.currentValue[0].totalOrigenDesconocido > 0 ? this.pieChartLabels.push(["Sin especificar", changes.data.currentValue[0].porcentajeSinEspecificar]) : null;

    this.pieChartData = [];

    changes.data.currentValue[0].totalATDP > 0 ? this.pieChartData.push(changes.data.currentValue[0].totalATDP) : null;
    changes.data.currentValue[0].totalContratos > 0 ? this.pieChartData.push(changes.data.currentValue[0].totalContratos) : null;
    changes.data.currentValue[0].totalPolizas > 0 ? this.pieChartData.push(changes.data.currentValue[0].totalPolizas) : null;
    changes.data.currentValue[0].totalOrigenDesconocido > 0 ? this.pieChartData.push(changes.data.currentValue[0].totalSinEspecificar) : null;

    this.pieChartColors = [
      {
        backgroundColor: [
          'rgba(135, 206, 250, 1.0)', // Celeste Claro
          'rgba(152, 251, 152, 1.0)', // Verde Pastel
          'rgba(255, 255, 178, 1.0)', // Amarillo Pastel
          'rgba(216, 191, 216, 1.0)', // Lila Suave
      ]
      }
    ];

  }

  public pieChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      position: 'bottom',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };

  public pieChartLabels = [];
  public pieChartData = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [pluginDataLabels];
  public pieChartColors = [
    /*{
      backgroundColor: ['rgba(0,255,0,0.3)', 'rgba(255,0,0,0.3)'],
    }*/
  ];
}
